import { render, staticRenderFns } from "./HomeScreen.vue?vue&type=template&id=52242ac0"
import script from "./HomeScreen.vue?vue&type=script&lang=js"
export * from "./HomeScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports